<script setup>

const resultSection = [
  {
    heading: "15+",
    text: "YEARS OF EXPERIENCE<br /> IN DIGITAL INDUSTRY",
  },
  {
    heading: "1M+",
    text: "HOURS OF<br /> QUALITY WORK",
  },
  {
    heading: "800+",
    text: "SUCCESSFUL<br /> PROJECTS DELIVERED",
  },
  {
    heading: "99%",
    text: "OF CUSTOMERS COME<br /> BACK TO US AGAIN",
  },
];
</script>
<template>
  <h3
    class="2xl:text-5xl lg:text-4xl text-3xl text-black dark:text-white text-center z-10"
  >
    Meticulous Process, Outstanding Results
  </h3>
  <div
    class="flex gap-7 justify-between items-center mt-12 max-lg:px-2 max-xl:flex-wrap lg:gap-y-12 lg:gap-7 relative z-10"
  >
 
    <template v-for="(result, index) in resultSection" :key="index" class="relative z-10">
      <div
        class="flex flex-col items-center justify-center text-center max-xl:w-[40%] max-md:w-full"
      >
        <p
          class="text-6xl font-semibold text-[rgba(126,57,167,1)] dark:text-white"
        >
          {{ result.heading }}
        </p>
        <p class="text-xl mt-5" v-html="result.text"></p>
      </div>
    </template>
  
  </div>
</template>

<style lang="scss" scoped></style>
